import { render, staticRenderFns } from "./purchasePlanAutoAction.vue?vue&type=template&id=61fa696a&scoped=true"
import script from "./purchasePlanAutoAction.vue?vue&type=script&lang=js"
export * from "./purchasePlanAutoAction.vue?vue&type=script&lang=js"
import style0 from "./purchasePlanAutoAction.vue?vue&type=style&index=0&id=61fa696a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa696a",
  null
  
)

export default component.exports